/* global app */
import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { SBIntegrations } from 'sb-integrations-lionsbet'

const { BetmanGame, useSession } = SBIntegrations

const Betman = ({ isLogged }) => {
    const session = useSession();
    const { lang, mainCountryCode } = app.config;
    const language = useMemo(() => `lang_${lang}_${mainCountryCode}_1_1`.toLocaleLowerCase());

    return (
        <BetmanGame
            session={isLogged ? session : ''}
            isMobile={false}
            lang={language}
            refreshBalance={app.service.Customer.refreshAccountBalance}
        />
    )
}

const mapStateToProps = ({ Auth: { isLogged } }) => {
    return {
        isLogged
    }
}

export default connect(mapStateToProps)(Betman)
